import { useState, useEffect } from 'react';
import {
    createBanner,
    deleteBanner,
    getBannerById,
    getBanners,
    updateBanner,
    getBannerPaginate,
    updateActive
} from '../services/BannerService';
import useAlert from '../../../shared/hooks/useAlert';

export const useBanner = () => {

    const [banner, setBanner] = useState([]);
    const [meta, setMeta] = useState({});
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { alert, showAlert } = useAlert();

    const fetchBanner = async (page = 1, limit = 10) => {
        try {
            setLoading(true);

            const response = await getBannerPaginate(page, limit);

            setBanner(response.data.data);
            setMeta(response.data.meta);

        } catch (err) {
            setError('Failed to fetch banner');
        } finally {
            setLoading(false);
        }
    };

    const fetchBannerById = async (id) => {
        setLoading(true);
        try {
            const response = await getBannerById(id);
            setBanner(response.data);
        } catch (err) {
            setError('Failed to fetch products');
        } finally {
            setLoading(false);
        }
    };

    const addBanner = async (bannerData) => {
        try {
            const response = await createBanner(bannerData);
            setBanner(prev => [...prev, response.data]); // use functional update
        } catch {
            setError('Failed to add product');
        }
    };

    const editBanner = async (id, updatedBanner) => {
        try {
            const response = await updateBanner(id, updatedBanner);
            setBanner(prev => prev.map(p => (p.id === id ? response.data : p)));
        } catch {
            setError('Failed to update product');
        }
    };

    const updateOnActive = async (id, updatedStatus) => {
        try {
            const response = await updateActive(id, updatedStatus);
            setBanner(prev => prev.map(p => (p.id === id ? response.data : p)));
            showAlert('Edited successfully!', 'success');
        } catch {
            setError('Failed to update categories');
            showAlert('Error creating', 'danger');
        }
    };

    const removeBanner = async (id) => {
        try {
            await deleteBanner(id);
            setBanner(prev => prev.filter(p => p.id !== id));
        } catch {
            setError('Failed to delete product');
        }
    };

    useEffect(() => {
        fetchBanner(1, 10);
    }, []);

    return {
        loading,
        error,
        banner,
        meta,
        fetchBannerById,
        addBanner,
        editBanner,
        removeBanner,
        fetchBanner,
        updateOnActive
    };

};